favbutton(class="{ props.mobile ? 'sp' : 'pc'}")
  template(if="{state.signedIn}")
    button(class="to_favorite {state.isFaved ? ' already' : ''}" onclick="{ postAction }" disabled="{ state.disabled }") { 'お気に入り' + (state.isFaved ? '済' : '') }
  template(if="{!state.signedIn}")
    a.to_favorite(href="/users/sign_in/"  rel='nofollow') お気に入り
  script.
    export default {
      onBeforeMount(props, state) {
        try {
          this.state.signedIn = !document.cookie.split(';').filter((item) => item.trim().startsWith('_tkn_signedin='))[0].includes('false')
        } catch (e) {
          this.state.signedIn = false
        }
        this.state.isFaved = false
        this.state.fetched = false
      },
      postAction(e) {
        this.update({
          disabled: "disabled"
        })
        if (this.state.isFaved) {
          this.props.loader.removeFromFavorite(this.props.watchid)
        } else {
          this.props.loader.addToFavorite(this.props.watchid)
        }
      },
      fetchOnVisible() {
        const target = this.root
        const t_height = target.offsetHeight
        const t_classN = target.className

        const offsetY = target.getBoundingClientRect().top

        const screenHeight = window.outerHeight

        const t_position = offsetY - screenHeight
        if (-screenHeight <= (t_position　+　t_height) && t_position < 0 && !this.state.fethced) {
          this.props.loader.fetchFavorite(this.props.watchid)
          this.state.fethced = true
        }
      },
      onMounted(props, state) {
        props.loader.on(props.loader.handler('add', props.watchid), () => {
          this.update({
            isFaved: true,
            disabled: ""
          })
        })
        props.loader.on(props.loader.handler('remove', props.watchid), () => {
          this.update({
            isFaved: false,
            disabled: ""
          })
        })
        props.loader.on(props.loader.handler('fetch', props.watchid), () => {
          this.isFaved = true
          this.fetched = true
          this.disabled = ""
          this.update({
            isFaved: true,
            fetched: true,
            disabled: ""
          })
        })

        if (this.state.signedIn) {
          this.postAction.bind(this)
          this.fetchOnVisible()
          window.addEventListener('scroll', this.fetchOnVisible)
        }
      }
    }
